<div class="dialog-container">
  <div class="dialog-header">
    <h3 class="title">Teams Meetings</h3>
    <button mat-icon-button aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="data?.candidates?.length; else emptyState">
    <div class="mat-elevation-z2 table-wrap">
      <table mat-table [dataSource]="data.candidates" class="full-width min-600">

        <!-- Title Column -->
        <ng-container matColumnDef="meetingTitle">
          <th mat-header-cell *matHeaderCellDef> Title </th>
          <td mat-cell *matCellDef="let c">
            {{ c.meetingTitle }}
          </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="meetingDate">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let c"> {{ c.meetingDate }} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-col"> Actions </th>
          <td mat-cell *matCellDef="let c" class="actions-col">
            <button mat-icon-button color="primary" matTooltip="Sync" (click)="createFromCandidate(c)">
              <mat-icon>sync</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['meetingTitle','meetingDate','actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['meetingTitle','meetingDate','actions'];"></tr>
      </table>
    </div>
  </div>

  <ng-template #emptyState>
    <div class="mat-elevation-z2 table-wrap">
      <table mat-table [dataSource]="[]" class="full-width min-600">
        <ng-container matColumnDef="meetingTitle">
          <th mat-header-cell *matHeaderCellDef> Title </th>
          <td mat-cell *matCellDef="let c"> - </td>
        </ng-container>
        <ng-container matColumnDef="meetingDate">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let c"> - </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-col"> Actions </th>
          <td mat-cell *matCellDef="let c" class="actions-col"> - </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['meetingTitle','meetingDate','actions']"></tr>
        <!-- No data rows intentionally omitted -->
      </table>
      <div class="empty">
        <p>No matching meetings found.</p>
        <button mat-raised-button color="primary" (click)="createNew()">
          <mat-icon>add</mat-icon>
          <span class="ms-1">Create meeting</span>
        </button>
      </div>
    </div>
  </ng-template>
</div>
